module.exports = __webpack_public_path__ + "static/media/e-mail.eee23072.svg";